module.exports = __webpack_public_path__ + "img/sy_ppwh1@3x.d0a29d0d.png";